var _style, _g, _g2, _g3, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgKmLogoVinfo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "\\u30EC\\u30A4\\u30E4\\u30FC_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "493.4px",
    height: "324px",
    viewBox: "0 0 493.4 324",
    style: {
      enableBackground: "new 0 0 493.4 324"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:none;}\n\t.st1{fill:#FFFFFF;}\n\t.st2{fill:url(#SVGID_1_);}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 5.1,
    y1: 162.6,
    x2: 40.2,
    y2: 162.6
  }), /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 490.1,
    y1: 162.6,
    x2: 455,
    y2: 162.6
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 247.6,
    y1: 40.3,
    x2: 247.6,
    y2: 5.2
  }), /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 247.6,
    y1: 321.4,
    x2: 247.6,
    y2: 286.3
  })))), /*#__PURE__*/React.createElement("g", null, _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M91.6,248.1c-9.8,0-17.7,8.3-17.7,18.4c0,10.2,7.9,18.4,17.7,18.4c9.8,0,17.7-8.3,17.7-18.4 C109.3,256.4,101.4,248.1,91.6,248.1z M91.6,279.6c-4.2,0-10.7-3.1-10.7-13c0-10,6.5-13.1,10.7-13.1c4.2,0,10.7,3.2,10.7,13.1 C102.3,276.5,95.8,279.6,91.6,279.6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M364.4,248.1c-9.8,0-17.7,8.3-17.7,18.4c0,10.2,7.9,18.4,17.7,18.4c9.8,0,17.7-8.3,17.7-18.4 C382.1,256.4,374.2,248.1,364.4,248.1z M364.4,279.6c-4.2,0-10.7-3.1-10.7-13c0-10,6.5-13.1,10.7-13.1c4.2,0,10.7,3.2,10.7,13.1 C375.1,276.5,368.6,279.6,364.4,279.6z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 40.2,
    y: 249,
    width: 6.7,
    height: 35.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 154.5,
    y: 249,
    width: 6.7,
    height: 35.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.1,253.8h2.8l0.3-4.7c-1.4-0.1-2.4-0.2-3.9-0.2c-13.6,0-22.3,7.2-22.3,17.6c0,10.4,8.8,17.6,22.3,17.6 c1.4,0,2.5-0.1,3.9-0.2l-0.3-4.7h-2.8c-9.3,0-15.7-4.5-15.7-12.7C174.4,258.4,180.8,253.8,190.1,253.8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.3,270C140.3,270,140.3,270,140.3,270c-4.7-8.6-14.7-17.6-20.8-21h-4.6v35.2h6.3c0,0-0.3-27.1-0.3-27.2 c0-0.1,0-0.1,0.1-0.1c7.6,5.2,15.5,15.3,19.9,27.2h5.6V249h-6.4C140.1,249,140.3,269.9,140.3,270z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M335,270C335,270,335,270,335,270c-4.7-8.6-14.7-17.6-20.8-21h-4.6v35.2h6.3c0,0-0.3-27.1-0.3-27.2c0-0.1,0-0.1,0.1-0.1 c7.6,5.2,15.5,15.3,19.9,27.2h5.6V249h-6.4C334.8,249,335,269.9,335,270z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 294.8,
    y: 249,
    width: 6.7,
    height: 35.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.2,284.1h6.3c0,0,9.5-22.3,9.8-23.1c0.4,0.8,11.7,23.1,11.7,23.1h7.5L211.5,248L195.2,284.1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M441.7,248l-16.3,36.1h6.3c0,0,9.5-22.3,9.8-23.1c0.4,0.8,11.7,23.1,11.7,23.1h7.5L441.7,248z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.3,263.3C62,259.4,72,249,72,249h-8l-14.6,15.4c7,4.6,12.9,10.9,16.5,19.8h7C70.2,275.8,64.9,268.2,58.3,263.3z"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "394.4,249 387.7,249 387.7,284.1 408,284.1 408,279.1 394.4,279.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "429.5,249 405,249 405,254 413.9,254 413.9,284.1 420.6,284.1 420.6,254 429.5,254  "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.9,265.4c-0.6,1.2-1.5,4-2.1,5.7c0,0-0.1,0-0.1,0c-0.6-1.6-1.5-4.4-2.1-5.6c-3-6.4-8.2-14.6-11.1-17.6 c-1.7,3.1-8.4,30.4-9.8,36.3h6.7c0,0,5-23.3,5.1-23.4c0-0.1,0.1-0.1,0.1,0c2.2,3.4,6.5,12.4,9.1,20.3h4.2 c2.4-7.4,6.9-16.8,9.1-20.2c0-0.1,0.1,0,0.1,0c0,0.1,5.1,23.3,5.1,23.3h6.7c-1.4-5.9-8.1-33.2-9.8-36.3 C277,250.9,271.9,259.1,268.9,265.4z"
  }))), /*#__PURE__*/React.createElement("g", null, _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M345.5,152.6c-0.2,0.3-0.4,0.4-0.7,0.3c-0.4,0-97.2-5.8-97.2-5.8s-96.8,5.7-97.2,5.8c-0.3,0-0.6-0.1-0.7-0.3 c0.3,1.1,0.7,2.2,1.1,3.3c-0.1-0.5,0.2-0.8,0.9-0.8h191.8c0.7,0,1,0.3,0.9,0.8C344.8,154.7,345.2,153.7,345.5,152.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M348.2,128.5c-3.6,0.3-69.2-3-100.6-3c-31.4,0-97,3.2-100.6,3c-0.4,0-0.8-0.2-0.8-0.5c0,0.5,0,1,0,1.5 s0,1,0,1.5c0.1-0.3,0.4-0.5,0.8-0.5c3.6-0.3,69.2,3,100.6,3c31.4,0,97-3.2,100.6-3c0.4,0,0.8,0.2,0.8,0.5c0-0.5,0-1,0-1.5 s0-1,0-1.5C349,128.3,348.6,128.5,348.2,128.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M347.3,140.6c-3-0.1-67.5-4.7-99.7-4.6c-32.1-0.1-96.7,4.4-99.7,4.6c-0.5,0-0.9-0.2-1.1-0.7 c0.2,1.1,0.3,2.2,0.5,3.3c0-0.5,0.4-0.7,1-0.7c0.8,0,78,2.1,99.3,2.1c21.2,0,98.5-2.1,99.3-2.1c0.6,0,1,0.2,1,0.7 c0.2-1.1,0.4-2.2,0.5-3.3C348.2,140.4,347.8,140.6,347.3,140.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M149.7,106.4c0.2-0.3,0.4-0.4,0.7-0.3c0.4,0,97.2,5.8,97.2,5.8s96.8-5.7,97.2-5.8c0.3,0,0.6,0.1,0.7,0.3 c-0.3-1.1-0.7-2.2-1.1-3.2c0.1,0.5-0.3,0.8-0.9,0.8H151.7c-0.7,0-1-0.3-0.9-0.8C150.4,104.2,150,105.3,149.7,106.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M148,118.4c3,0.1,67.6,4.7,99.7,4.6c32.1,0.1,96.7-4.4,99.7-4.6c0.5,0,0.9,0.2,1.1,0.6 c-0.2-1.1-0.3-2.2-0.5-3.3c0,0.5-0.4,0.7-1,0.7c-0.8,0-78-2.1-99.3-2.1c-21.2,0-98.5,2.1-99.3,2.1c-0.6,0-1-0.2-1-0.7 c-0.2,1.1-0.4,2.2-0.5,3.3C147,118.6,147.4,118.4,148,118.4z"
  }))), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_1_",
    cx: 247.4751,
    cy: 202.7953,
    r: 119.5757,
    gradientTransform: "matrix(1 0 0 -0.9259 0.1401 294.7341)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#9BC4F0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5933,
    style: {
      stopColor: "#0075D2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#014880"
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M151.7,104h191.8c0.8,0,1.1-0.4,0.9-1.1c-13-35.5-51.4-61.3-96.8-61.3c-45.4,0-83.8,25.8-96.8,61.3 C150.6,103.6,151,104,151.7,104z M147,128.5c3.6,0.3,69.2-3,100.6-3c31.4,0,97,3.2,100.6,3c0.5,0,0.9-0.3,0.9-0.7 c-0.1-2.7-0.3-5.6-0.7-8.6c-0.1-0.7-0.5-0.9-1.1-0.9c-3,0.1-67.5,4.7-99.7,4.6c-32.1,0.1-96.7-4.4-99.7-4.6 c-0.6,0-1.1,0.2-1.1,0.9c-0.4,2.9-0.6,5.9-0.7,8.6C146.1,128.2,146.5,128.5,147,128.5z M148.4,116.4c0.8,0,78-2.1,99.3-2.1 c21.2,0,98.5,2.1,99.3,2.1c0.6,0,1.1-0.3,1-0.9c-0.5-2.9-1.3-6-2.2-9c-0.1-0.4-0.5-0.5-0.8-0.5c-0.4,0-97.2,5.8-97.2,5.8 s-96.8-5.7-97.2-5.8c-0.3,0-0.7,0.1-0.8,0.5c-0.9,3-1.7,6.1-2.2,9C147.3,116.1,147.7,116.4,148.4,116.4z M150.9,156 c13,35.5,51.4,61.3,96.8,61.3c45.4,0,83.8-25.8,96.8-61.3c0.2-0.7-0.1-1.1-0.9-1.1H151.7C151,155,150.6,155.4,150.9,156z  M146.2,131.1c0.1,2.7,0.3,5.6,0.7,8.6c0.1,0.7,0.5,0.9,1.1,0.9c3-0.1,67.6-4.7,99.7-4.6c32.1-0.1,96.7,4.4,99.7,4.6 c0.6,0,1.1-0.2,1.1-0.9c0.4-2.9,0.6-5.9,0.7-8.6c0-0.4-0.4-0.6-0.9-0.7c-3.6-0.3-69.2,3-100.6,3c-31.4,0-97-3.2-100.6-3 C146.5,130.5,146.1,130.7,146.2,131.1z M147.4,143.4c0.5,2.9,1.3,6,2.2,9c0.1,0.4,0.5,0.5,0.8,0.5c0.4,0,97.2-5.8,97.2-5.8 s96.8,5.7,97.2,5.8c0.3,0,0.7-0.1,0.8-0.5c0.9-3,1.7-6.1,2.2-9c0.1-0.6-0.3-0.9-1-0.9c-0.8,0-78,2.1-99.3,2.1 c-21.2,0-98.5-2.1-99.3-2.1C147.7,142.5,147.3,142.8,147.4,143.4z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKmLogoVinfo);
export default __webpack_public_path__ + "static/media/km_logo_vinfo.e68661655efb94c684621137e2f0318c.svg";
export { ForwardRef as ReactComponent };